module.exports = __webpack_public_path__ + "static/media/crow_roti02.9f0db315.gif";